import wixLocation from 'wix-location';

$w.onReady(function () {
    $w("#listRepeater").onItemReady(($item, itemData) => {
        // הקפד שה-URL Slug משודך נכון ב-Dataset
        const urlSlug = itemData.slug;

        // הפניה לדף הדינאמי בלחיצה
        $item("#container1").onClick(() => {
            wixLocation.to(`/activities/${itemData.slug}`);
        });
    });
});